<script setup>
import { computed } from 'vue';
import { useTimeHelper } from 'shared/composables/useTimeHelper';
import { getWeekdayLabels } from '../helpers/DatePickerHelper';

const { dateFnsLocale } = useTimeHelper();

const weekdays = computed(() => getWeekdayLabels(dateFnsLocale.value));
</script>

<template>
  <div class="max-w-md mx-auto grid grid-cols-7 gap-2">
    <div
      v-for="day in weekdays"
      :key="day.id"
      class="flex items-center justify-center font-medium text-sm capitalize w-9 h-7 py-1.5 px-2"
    >
      {{ day.label }}
    </div>
  </div>
</template>
